import { render, staticRenderFns } from "./Nieuws.vue?vue&type=template&id=f3aa8a8a&scoped=true&"
import script from "./Nieuws.vue?vue&type=script&lang=js&"
export * from "./Nieuws.vue?vue&type=script&lang=js&"
import style0 from "./Nieuws.vue?vue&type=style&index=0&id=f3aa8a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3aa8a8a",
  null
  
)

export default component.exports